import React, { useMemo } from 'react';
import { Switch } from '.';
import { Pane, Select, Text } from 'evergreen-ui';
import styled from 'styled-components';

const CustomSelect = styled(Select)`
  select {
    background-color: #1e262c;
    color: #f0f0f2;
    opacity: ${({ muted }) => (muted ? 0.5 : 1)};
    border: none;
    :active,
    :focus,
    :hover {
      background-color: #1e262c !important;
      color: #f0f0f2;
      opacity: ${({ muted }) => (muted ? 0.5 : 1)};
      border: none;
    }
  }
`;

const DayFilterCard = ({ dayOfTheWeek, value, setValue, active, setActive, disabled }) => {
  const hoursAndMinutes = useMemo(() => {
    const values = [];
    for (let i = 0; i < 1441; i += 30) {
      const hours = Math.floor(i / 60);
      const minutes = i % 60;
      values.push(`${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`);
    }
    return values;
  }, []);

  return (
    <Pane paddingX={22}>
      <Pane
        display="flex"
        flexDirection="row"
        justifyContent="space-between"
        alignItems="center"
        paddingY={22}
        borderBottom="1px solid rgba(228, 245, 255, 0.5)"
      >
        <Text color="#F0F0F2" opacity={active ? 1 : 0.5}>
          {dayOfTheWeek}
        </Text>
        <Pane>
          <Text color="##F0F0F2" opacity={0.5}>
            Start
          </Text>
          <CustomSelect
            disabled={disabled}
            muted={!active}
            value={value[0]}
            onChange={e => {
              const end = e.target.value > value[1] ? e.target.value : value[1];
              setValue([e.target.value, end]);
            }}
          >
            {hoursAndMinutes.map(item => (
              <option key={item} value={item}>
                {item}
              </option>
            ))}
          </CustomSelect>
        </Pane>
        <Pane>
          <Text color="##F0F0F2" opacity={0.5}>
            End
          </Text>
          <CustomSelect
            disabled={disabled}
            muted={!active}
            value={value[1]}
            onChange={e => {
              setValue([value[0], e.target.value]);
            }}
          >
            {hoursAndMinutes.map(item => (
              <option key={item} value={item}>
                {item}
              </option>
            ))}
          </CustomSelect>
        </Pane>
        <Switch
          checked={active}
          disabled={disabled}
          onChange={checked => {
            setActive(checked);
          }}
        />
      </Pane>
    </Pane>
  );
};

export default DayFilterCard;
